// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","inner":"Footer_inner__X-XDt","links":"Footer_links__nI2fs","link":"Footer_link__ljLIL"};